export const status = [
  { name: "Full Time", value: 1 },
  { name: "Part Time", value: 2 },
];
